enum ButtonSize {
  MEDIUM = 'm',
  SMALL = 's',
}

export { ButtonSize };
